import { render, staticRenderFns } from "./premium-lawyer-badge.vue?vue&type=template&id=39a893f4"
import script from "./premium-lawyer-badge.vue?vue&type=script&lang=js"
export * from "./premium-lawyer-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports